import { render, staticRenderFns } from "./history-account-status.vue?vue&type=template&id=b3a1337e&scoped=true"
import script from "./history-account-status.vue?vue&type=script&lang=js"
export * from "./history-account-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a1337e",
  null
  
)

export default component.exports